/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Assign_EmptyInputs */

const en_us2_coaching_assign_empty = /** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save a template first, on the Coaching screen.`)
};

const pt_br2_coaching_assign_empty = /** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salve um modelo primeiro, na tela Personal.`)
};

const pt_pt2_coaching_assign_empty = /** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salve um modelo primeiro, na tela Personal.`)
};

/** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */
const es_419_coaching_assign_empty = en_us2_coaching_assign_empty;

/** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */
const fr_fr2_coaching_assign_empty = en_us2_coaching_assign_empty;

/** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */
const de_de2_coaching_assign_empty = en_us2_coaching_assign_empty;

/** @type {(inputs: Coaching_Assign_EmptyInputs) => LocalizedString} */
const it_it2_coaching_assign_empty = en_us2_coaching_assign_empty;

/**
* | output |
* | --- |
* | "Save a template first, on the Coaching screen." |
*
* @param {Coaching_Assign_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_assign_empty = /** @type {((inputs?: Coaching_Assign_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Assign_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_assign_empty(inputs)
	if (locale === "es-419") return es_419_coaching_assign_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_assign_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_assign_empty(inputs)
	if (locale === "de-DE") return de_de2_coaching_assign_empty(inputs)
	if (locale === "it-IT") return it_it2_coaching_assign_empty(inputs)
	return en_us2_coaching_assign_empty(inputs)
});
export { coaching_assign_empty as "coaching.assign_empty" }